// Serveur de développement (Plesk). Utilisé par le déploiement CI : `ng build --configuration=dev`.
export const environment = {
    api_url: 'https://lamas-api.digi4dev.ma/api/',
    secure_key: 'YRbrd9Zg9UdnM87hHzbp969SmBqsgYNRsPLnYd95mCf5UFJRgQJ5a8EBVf5Yx',
    production: false,

    // Badge d'environnement
    badge_env: {
        show: true,
        label: 'Développement', // 'Développement' || 'Préproduction' || 'Production'
        color: '#4361ee'
    }
};
